import {createFileRoute} from '@tanstack/react-router'

import TimingScreen from '@protected/timing'

export const Route = createFileRoute('/_protected/timing')({component: TimingScreen})
